const likeMap = {
  'like': '👍',
  'congrat': '👏',
  'love': '❤️',
  'funny': '😂',
  'instructive': '📚',
  'care': '🤝'
}
const likeColorMap = {
  'like': 'royalblue',
  'congrat': 'orange',
  'love': '#953D51',
  'funny': 'orange',
  'instructive': 'green',
  'care': 'orange'
}

const getLikeIcon = (type) => likeMap[type]

const getLikesIcons = likes => {
  let types = (likes || []).map(like => like.type)
  return Object.keys(likeMap).filter(type => types.includes(type)).map(getLikeIcon)
}

const getLikeText = (type) => 'post.reactions.' + type

const getLikesConfig = () => {
  return Object.entries(likeMap).map(([type, icon]) => ({
    type, icon, text: getLikeText(type)
  }))
}

const getLikeStyle = (type) => {
  if (!type) {
    return {}
  }
  return ({
    'font-weight': 'bold',
    'color': likeColorMap[type]
  })
}

export default {
  getLikeIcon,
  getLikeText,
  getLikeStyle,
  getLikesIcons,
  getLikesConfig
}
